import { useState } from "react";

export default function usePagination(data, itemsPerPage) {
  const [currentPage, setCurrentPage] = useState(1);
  const [dataset, setDataset] = useState(data);

  const maxPage = Math.ceil(dataset.length / itemsPerPage);

  // Data sesuai halaman aktif
  function currentData() {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return dataset.slice(begin, end);
  }

  // Loncat ke halaman tertentu
  function jump(page) {
    const pageNumber = Math.max(1, Math.min(page, maxPage));
    setCurrentPage(pageNumber);
  }

  // Update data + reset ke halaman pertama
  function setData(newData) {
    setDataset(newData);
    setCurrentPage(1);
  }

  return { currentData, jump, maxPage, currentPage, setData };
}
